exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#poll-table-header{display:flex;justify-content:space-between}#dashboard{display:flex;flex-direction:column;min-height:100%}.answer{min-width:300px!important}.struct-table{flex:1 0 auto}#wrapper{min-height:50vh}#calling-list-table{flex:0 1 auto}.action-buttons{display:flex;flex-direction:column}.recall-btn{width:80px}.phone-icon{font-size:1.5rem}.search-buttons{display:flex;width:fit-content;margin-left:1rem;margin-bottom:.5rem}.faq-script{font-size:.8rem}.phone{margin-left:2rem}.short-list{display:none}.interview-cell{min-width:210px}.line-cell{min-width:90px}.action-cell{min-width:150px}.comment-cell{min-width:300px}@media (max-width:536px){.faq-script,.finish-call{margin-top:1rem}.pat-name{font-size:1.2rem}.phone{margin-left:0}.short-list{display:block}.recall-btn{width:60px}#poll-table-header{flex-direction:column;margin-bottom:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5caded5a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard.vue
// module id = 649
// module chunks = 0